const firebaseConfig = {
    apiKey: "AIzaSyDuCzjD7qjHnaqxUFqlUsS42yOnSMQFjZs",
    authDomain: "sheba-health-care.firebaseapp.com",
    projectId: "sheba-health-care",
    storageBucket: "sheba-health-care.appspot.com",
    messagingSenderId: "660882529329",
    appId: "1:660882529329:web:4b61b2c7d0e49b2d2f4910"
  };
  export default firebaseConfig;